import { DEFAULT_UNITS } from './catalog.js';
function normalizeAlias(text) {
    return text.toLowerCase().normalize('NFKC').replace(/\s+/g, ' ').replace(/\.$/, '').trim();
}
const aliasIndex = new Map();
for (const unit of DEFAULT_UNITS) {
    aliasIndex.set(normalizeAlias(unit.code), unit);
    for (const alias of unit.aliases)
        aliasIndex.set(normalizeAlias(alias), unit);
    for (const form of ['singular', 'plural', 'abbreviation']) {
        aliasIndex.set(normalizeAlias(unit.labels[form].de), unit);
        aliasIndex.set(normalizeAlias(unit.labels[form].en), unit);
    }
}
/** Longest alias first so "fl oz" wins over "oz". */
export const UNIT_ALIASES_BY_LENGTH = [...aliasIndex.keys()].sort((a, b) => b.length - a.length);
/**
 * Resolve a unit alias or localized abbreviation to a catalog unit.
 * Returns undefined when the text is not a known unit.
 */
export function normalizeUnit(text) {
    if (!text)
        return undefined;
    const key = normalizeAlias(text);
    if (!key)
        return undefined;
    return aliasIndex.get(key) ?? aliasIndex.get(key.replace(/\./g, ''));
}
export function isKnownUnit(text) {
    return normalizeUnit(text) !== undefined;
}
//# sourceMappingURL=normalize.js.map